<template>
	<el-container :class="{ 'dashboard-layout': $route.path === '/Dashboard' }"
		style="min-height: 100vh; display: flex; flex-direction: column;">
		<el-header v-if="$route.path !== '/Dashboard'" style="flex-shrink: 0;" class="elheader">
			<MyHeader @getData="getData"></MyHeader>
		</el-header>

		<el-container style="flex: 1; overflow: hidden; display: flex;">
			<el-aside v-if="$route.path !== '/Dashboard'" :width="sidebarWidth" class="sidebar">
				<MyAside :msg="isCollapse" />
			</el-aside>

			<el-main :class="{ 'dashboard-main': $route.path === '/Dashboard' }" style="overflow-y: auto; padding: 0;">
				<div v-if="$route.path !== '/Dashboard'" class="mainbackcolor">
					<el-tabs v-model="editableTabsValue" type="card" closable @tab-remove="removeTab" @tab-click="changeTab">
						<el-tab-pane :closable="false" label="首页" name="/Home"></el-tab-pane>
						<el-tab-pane v-for="(item, index) in editableTabs" :key="item.name" :label="item.title" :name="item.name">
						</el-tab-pane>
					</el-tabs>
				</div>
				<transition name="slide-left" mode="out-in">
					<router-view key="routerView" class="router-view-wrapper" />
				</transition>
			</el-main>
		</el-container>
	</el-container>
</template>

<script>
import MyAside from "./components/Aside.vue";
import MyHeader from "./components/Header.vue";

export default {
	data () {
		return {
			isCollapse: false,
			editableTabsValue: '/Home',
			editableTabs: [],
			minw: false,
			// 侧边栏宽度配置
			collapsedWidth: '60px',
			expandedWidth: '180px'
		}
	},
	computed: {
		// 动态计算侧边栏宽度
		sidebarWidth () {
			// 优先根据折叠状态判断
			if (this.isCollapse) {
				return this.collapsedWidth;
			}
			// 根据屏幕宽度判断
			if (this.minw) {
				return this.collapsedWidth;
			}
			return this.expandedWidth;
		}
	},

	methods: {
		getData (data) {
			this.isCollapse = data;
		},
		removeTab (targetName) {
			let tabs = this.editableTabs;
			let activeName = this.editableTabsValue;
			if (activeName === targetName) {
				tabs.forEach((tab, index) => {
					if (tab.name === targetName) {
						let nextTab = tabs[index + 1] || tabs[index - 1];

						if (nextTab) {
							activeName = nextTab.name;

						}
					}
				});
			}

			this.editableTabsValue = activeName;
			if (tabs.length > 1) {
				this.$router.push(activeName)
			} else {
				this.$router.push('/Home')
			}

			this.editableTabs = tabs.filter(tab => tab.name !== targetName);
		},
		changeTab (name) {

			if (name.name == '/Home') {
				sessionStorage.setItem('setIsTabChange', false); // 设置为 true
				this.$router.push(name.name)
			} else {
				sessionStorage.setItem('setIsTabChange', true); // 设置为 true
				this.$router.push(name.name)
			}

		},
		handleResize () {

			const width = window.innerWidth;
			// console.log('width', width);
			this.minw = width <= 1030;
			this.isCollapse = width <= 1030; // 小于等于 768px 时折叠
			// console.log('this.isCollapse', this.isCollapse);
		}
	},
	components: {
		MyAside,
		MyHeader,
	},
	watch: {
		'$route': function (to, from) {
			// 当前路由变化时调用此函数
			// to 是新的路由对象，from 是旧的路由对象
			// console.log('Route changed from', from, 'to', to);
			if (to.fullPath !== '/Home' && to.fullPath !== '/Dashboard') {

				const Tabs = {
					title: to.meta.label,
					name: to.fullPath
				}
				// 使用 find 方法检查 editableTabs 数组中是否存在 Tabs 对象
				const existingTab = this.editableTabs.find(tab =>
					tab.name === Tabs.name
				);

				// 如果不存在并且不是 /home 路径，就添加到 editableTabs 数组中
				if (!existingTab) {
					this.editableTabs.push(Tabs);
				}

			}
			this.editableTabsValue = to.fullPath;
		}
	},
	mounted () {
		this.handleResize(); // 初始化判断一次
		window.addEventListener('resize', this.handleResize);
	},
	beforeDestroy () {
		window.removeEventListener('resize', this.handleResize); // 清理事件
	},
};
</script>

<style scoped>
html,
body {
	height: 100%;
	margin: 0;
	padding: 0;
}

::v-deep .el-main {
	padding: 0;
	margin: 0;
	background-color: #f5f7fa;
	display: flex;
	flex-direction: column;
	height: 100%;
	box-sizing: border-box;
}

.editableTabsValue {
	background-color: #ffffff;
	padding: 1rem;
	padding-bottom: 0;
}

.el-header {
	padding: 0px;
	margin: 0px;
	border-bottom: 2px solid #e4e9ee;
}

/* 侧边栏样式优化 */
.sidebar {
	background: #FFF;
	transition: width 0.3s ease;
	box-sizing: border-box;
	flex-shrink: 0;
	height: 100%;
	overflow: hidden;
}

/* 修复内部菜单容器的滚动条样式，使其适配深色背景 */
.sidebar .corlo {
	height: 100% !important;
	/* background-color: #409EFF !important; */

	&::-webkit-scrollbar {
		width: 6px;
	}

	&::-webkit-scrollbar-track {
		background: rgba(255, 255, 255, 0.1);
	}

	&::-webkit-scrollbar-thumb {
		background: rgba(255, 255, 255, 0.3);
		border-radius: 3px;
		transition: background 0.3s ease;
	}

	&::-webkit-scrollbar-thumb:hover {
		background: rgba(255, 255, 255, 0.5);
	}
}

/* 修复菜单文字颜色，确保在深色背景下可见 */
.sidebar .el-menu {
	background-color: transparent !important;
	border-right: none !important;
}

.sidebar .el-menu-item,
.sidebar .el-submenu__title {
	color: rgba(255, 255, 255, 0.9) !important;
}

.sidebar .el-menu-item:hover,
.sidebar .el-submenu__title:hover {
	background-color: rgba(255, 255, 255, 0.1) !important;
}

.sidebar .el-menu-item.is-active {
	color: #fff !important;
	background-color: rgba(255, 255, 255, 0.2) !important;
}

/* 路由视图容器：增加最小高度避免塌陷 */
.router-view-wrapper {
	flex: 1;
	width: 100%;
	background-color: #f5f7fa;
	overflow-y: auto;
	transform: translateZ(0);
	will-change: transform, opacity;
	box-sizing: border-box;

	&::-webkit-scrollbar {
		width: 6px;
		height: 6px;
	}

	&::-webkit-scrollbar-track {
		background: #f1f1f1;
		border-radius: 3px;
	}

	&::-webkit-scrollbar-thumb {
		background: #c1c1c1;
		border-radius: 3px;
		transition: background 0.3s ease;
	}

	&::-webkit-scrollbar-thumb:hover {
		background: #a8a8a8;
	}

	&::-webkit-scrollbar-corner {
		background: #f1f1f1;
	}
}

/* 过渡动画样式 */
.slide-left-enter {
	opacity: 0;
	transform: translate3d(-100%, 0, 0);
}

.slide-left-enter-active {
	transition: transform 0.4s ease-in-out, opacity 0.4s ease-in-out;
}

.slide-left-leave-to {
	opacity: 0;
	transform: translate3d(100%, 0, 0);
}

.slide-left-leave-active {
	transition: transform 0.4s ease-in-out, opacity 0.4s ease-in-out;
}

::v-deep .el-tabs__header {
	margin-bottom: 2px;
}

::v-deep .el-tabs--card>.el-tabs__header {
	border: none;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
	width: 200px;
	height: 100%;
}

.el-submenu .el-menu {
	transition: all 0.3s ease;
}

/* tabs 容器：不伸缩，固定高度 */
.mainbackcolor {
	position: sticky;
	top: 0;
	z-index: 999;
	background-color: rgba(255, 255, 255, 0.6);
	backdrop-filter: blur(10px);
	-webkit-backdrop-filter: blur(10px);
	border-bottom: 1px solid rgba(0, 0, 0, 0.1);
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	flex-shrink: 0;
	min-height: 42px;
}

/* 响应式布局优化 */
@media (max-width: 1030px),
(max-device-width: 1030px) and (orientation: landscape) {

	.slide-left-enter,
	.slide-left-leave-to {
		transform: translateX(-100%);
		opacity: 0;
	}

	.slide-left-enter-active,
	.slide-left-leave-active {
		transition: transform 0.3s linear, opacity 0.3s linear;
	}
}
</style>